import React from 'react';

import { useFeatureDisclaimers } from 'features/content/hooks/use-feature-disclaimers';
import { StyleSheet, Text } from 'react-native';

import Picture from 'components/picture';
import { Box } from 'components/ui/box';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

const DeliveryDisclaimer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { deliveryDisclaimer, deliveryLogo } = featureDisclaimers || {};

  // The second condition is a safeguard against a Sanity bug with `localeString`
  // Refs. https://rbidigital.slack.com/archives/CCHFM51A8/p1620400033200600
  if (!deliveryDisclaimer || !deliveryDisclaimer.locale?.trim()) {
    return null;
  }

  return (
    <Box style={styles.deliveryDisclaimerContainer}>
      <Text style={styles.deliveryDisclaimerText}>{deliveryDisclaimer.locale}</Text>
      {deliveryLogo && (
        <Box style={styles.deliveryLogoContainer}>
          <Picture image={deliveryLogo.locale} alt={t('deliveryLogoAlt')} objectFitContain />
        </Box>
      )}
    </Box>
  );
};

const styles = StyleSheet.create({
  deliveryDisclaimerContainer: {
    marginTop: spacing.$4,
  },
  deliveryDisclaimerText: {
    fontSize: primitive.fontSizes['2xs'],
    textAlign: 'center',
  },
  deliveryLogoContainer: {
    alignSelf: 'center',
    width: spacing.$40,
  },
});

export default DeliveryDisclaimer;
